import throttle from "lodash/throttle";
import type { Logger } from "../logger";

/**
 * Returns a throttled `error()` function that uses the given logger.
 * Useful in situations where something is happening very frequently
 * (e.g. a scroll event handler) and we want to be able to log errors
 * there without potentially spamming Datadog into oblivion.
 */
export function makeThrottledLogError(
  logger: Logger | undefined,
  wait: number,
) {
  const throttledLogError = throttle(
    // Use `unknown` type for `error` to support easy usage in catch blocks
    (message: string, messageContext?: object | undefined, error?: unknown) => {
      if (error instanceof Error) {
        logger?.error(message, messageContext, error);
      } else {
        logger?.error(message, messageContext);
      }
    },
    wait,
    { leading: true, trailing: false },
  );

  return throttledLogError;
}
